<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
  const SLOTS = $$props.$$slots || {};

  export let options = [];
  export let selected = options[0];

  $: selectedIndex = options.indexOf(selected);

  let selectOption = function (option) {
    selected = option;
    dispatch('selected', { option: option });
  };
</script>

<style style="text/scss" lang="scss">
  .switch {
    background: #f9f7fc;
    padding: 6px;
    border-radius: 15px;

    .switch-option {
      display: flex;
      position: relative;
      height: 39px;

      label {
        padding-top: 10px;
        padding-bottom: 10px;
        border: none;
        background: transparent;
        font-weight: 500;
        text-align: center;
        opacity: 0.5;
        z-index: 1;
        cursor: pointer;
      }

      .switch-active {
        z-index: 2;
        color: white;
        opacity: 1;
      }

      .switch-selector {
        position: absolute;
        z-index: 1;
        height: 100%;
        left: 0;
        background: #a893f9;
        border-radius: 15px;
        transition: all 0.2s ease-in-out;
      }
    }
  }
</style>

<div class="switch {$$props.class}">
  <div class="switch-option {$$props.optionClass}">
    {#each options as option}
      <label
        style="width: {100 / options.length}%"
        for="#"
        on:click={() => {
          selectOption(option);
        }}
        class={$$props.labelClass}
        class:switch-active={selected == option}>
        {#if SLOTS.content}
          <slot name="content" option={option} />
        {:else}
          {@html option}
        {/if}
      </label>
    {/each}
    <span
      class="switch-selector {$$props.selectorClass}"
      style="width: {100 / options.length}%; left: {(selectedIndex / options.length) * 100}%" />
  </div>
</div>
